module.exports = kolibriGlobal.coreVue.components.KRouterLink;